import { render, staticRenderFns } from "./contatos.vue?vue&type=template&id=fbc0c826"
import script from "./contatos.vue?vue&type=script&lang=js"
export * from "./contatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports